import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/chipLogo.png'


const _withScopeId = n => (_pushScopeId("data-v-1f5c7544"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "wrapper" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "card__bank-name" }, "BANK", -1 /* HOISTED */))
const _hoisted_4 = { class: "card__pay-service" }
const _hoisted_5 = ["src"]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card__chip" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "card-chip",
    class: "card__chip--img"
  })
], -1 /* HOISTED */))
const _hoisted_7 = { class: "card__number" }
const _hoisted_8 = { class: "wrapper" }
const _hoisted_9 = { class: "card__info" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "card__info--owner" }, "John Doe", -1 /* HOISTED */))
const _hoisted_11 = { class: "card__info--inputs" }

import { useModal } from '@/store';
import { storeToRefs } from 'pinia';


export default /*#__PURE__*/_defineComponent({
  __name: 'ModalPayCard',
  setup(__props) {

const { cardServiceImg } = storeToRefs(useModal());

return (_ctx: any,_cache: any) => {
  const _component_AppInput = _resolveComponent("AppInput")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        (_unref(cardServiceImg))
          ? (_openBlock(), _createElementBlock("img", {
              key: 0,
              src: _unref(cardServiceImg),
              alt: "pay-service",
              class: "card__pay-service--img"
            }, null, 8 /* PROPS */, _hoisted_5))
          : _createCommentVNode("v-if", true)
      ])
    ]),
    _hoisted_6,
    _createElementVNode("div", _hoisted_7, [
      _createVNode(_component_AppInput, { field: 'card' })
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        _hoisted_10,
        _createElementVNode("div", _hoisted_11, [
          _createVNode(_component_AppInput, {
            class: "date",
            field: 'date'
          }),
          _createVNode(_component_AppInput, {
            class: "cvv",
            field: 'CVV'
          })
        ])
      ])
    ])
  ]))
}
}

})